import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { API } from 'aws-amplify';
import { IRecipient, ICount } from '../../../models/INotifications';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';

API.configure({
    endpoints: [
        {
            name: "portal",
            endpoint: environment.aws.apiEndpoint
        }
    ]
});

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    constructor(private http: HttpClient) { }

    getRecipients(category, categoryValue, dtStart?, dtEnd?) {
        let APICall;

        if (category === "session" || category === "guest") {
            let body = {
                "ParticipantID": categoryValue
            };
            APICall = API.post('portal', 'adhoc/' + category + '/reciepients', { body: body });
        }
        else if (category === "meeting") {
            let filter: string = dtStart + "," + dtEnd;
            const regex = new RegExp('%2C', "g");

            APICall = API.get('portal', 'adhoc/' + category + '/reciepients/' + encodeURIComponent(categoryValue).replace(regex, ',') + '/filter/' + filter, {});
        }
        else {
            APICall = API.get('portal', 'adhoc/' + category + '/reciepients/' + categoryValue, {});
        }

        return from(APICall).pipe(
            catchError((error) => {
                return throwError(error);
            }),
            map(data => {
                return data as IRecipient[];
            })
        );
    }

    getRecipientCount(category, categoryValues) {
        return from(API.get('portal', 'adhoc/' + category + '/reciepients/' + categoryValues + '/count', {})).pipe(
            map(data => {
                return data as ICount;
            })
        );
    }
    // can bimal make change to not pass comma list.
    getCategoryFilterValues(category, dtStart, dtEnd) {
        let filter: string = dtStart + "," + dtEnd;
        return from(API.get('portal', 'adhoc/' + category + '/filter/' + filter, {})).pipe(
            map(data => {
                return data;
            })
        );
    }

    getCategoryValues(category) {
        return from(API.get('portal', 'adhoc/' + category, {})).pipe(
            map(data => {
                return data;
            })
        );
    }

    public sendNotification(category, messageType, msgTitle, notificationBody, participants, senderEmail, categoryItemNames, alertBody, sendType, scheduleDateTime, isAllSelected, dtStart, dtEnd) {

        // notificationBody = notificationBody.replace(/[\u202F]/g, '');
        // notificationBody = this.utf8ToLatin1(notificationBody);
        if (category === "guest" || category === "email") {
            if (category === "email") {

                isAllSelected = false;
                let currentDate = new Date();
                const dd = String(currentDate.getDate()).padStart(2, '0');
                const mm = String(currentDate.getMonth() + 1).padStart(2, '0'); //January is 0!
                const yyyy = currentDate.getFullYear();
                let formattedDate = yyyy + '-' + mm + '-' + dd;
                dtStart = formattedDate;
                dtEnd = formattedDate;
            }
            // Validate dtStart and dtEnd
            if (!dtStart || isNaN(Date.parse(dtStart))) {
                return throwError(() => new Error("Invalid dtStart parameter"));
            }
            if (!dtEnd || isNaN(Date.parse(dtEnd))) {
                return throwError(() => new Error("Invalid dtEnd parameter"));
            }
            categoryItemNames = [{
                name: category,
                id: 0,
                dtStart: `${dtStart} 00:00:00`,
                dtEnd: `${dtEnd} 23:59:59`
            }]
        }

        const messageData = {
            category,
            categoryId: "999",
            recipients: isAllSelected ? [] : (typeof participants === 'string' && participants.trim().length > 0
                ? participants.split(',').map(Number)
                : []),
            allUsers: isAllSelected,
            attributes: categoryItemNames,
            message: {
                messageType,
                msgTitle,
                notificationBody,
                alertBody,
                senderEmail
            },
            sendType: sendType,
            scheduleDateTime: sendType !== "schedule" ? undefined : scheduleDateTime,
        };

        return from(API.post('portal', 'adhoc/message', { body: messageData }));
    }

    encodeHTML(html: string): string {
        return html
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    utf8ToLatin1(str: string) {
        // Create a TextEncoder and TextDecoder for UTF-8
        const encoder = new TextEncoder();
        const decoder = new TextDecoder('iso-8859-1', { fatal: true });

        // Encode UTF-8 string to bytes
        const utf8Bytes = encoder.encode(str);
        // Decode the UTF-8 bytes into a Latin-1 string (ISO-8859-1)
        return decoder.decode(utf8Bytes);
    }
    postEmailRecipients(emails: any) {
        let body = {
            "category": "email",
            "attributes": emails
        };
        return from(API.post('portal', 'adhoc/recipients', { body: body })).pipe(
            map(data => {
                return data;
            })
        );
    }

         public fileUploadParticipants(formData: FormData): Observable<string> {
            return from(API.post('portal', `adhoc/file-upload`, { body: formData })).pipe(
                catchError((error) => {
                    return throwError(error);
                }),
                map((res: string) => {
                    return res as string;
                })
            );
        }


}
